import { BACKEND_URL } from "../constants/environments";

export const updateOrCreateMercadoPagoCredentialsRequest = async (
  mercadopagoCode,
  countryCode,
  organizationAlias
) => {
  const url = `${BACKEND_URL}/organization/gateway/link/mercadopago/${countryCode}`;
  const data = {
    code: mercadopagoCode,
    alias: organizationAlias,
  };
  try {
    console.log({ url, data });
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const responseData = await response.json();
      console.log(responseData);
      return responseData;
    } else {
      console.warn("Error en la solicitud:", response.status);
      console.warn("Response en la solicitud:", {
        response: await response.json(),
      });
    }
  } catch (error) {
    console.error("Error en la solicitud:", error);
  }
  return undefined;
};
